/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import JobServices from '../../../../services/job'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'
import ChangePeriod from './ChangePeriod'
import {dateFormat} from 'thesis-and-dissertations/helpers/helper'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Nama Pekerjaan',
  },
  {
    name: '',
    label: 'Perusahaan',
  },
  {
    name: '',
    label: 'Daftar',
  },
  {
    name: '',
    label: 'Tutup',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const CompanyPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [filter, setFilter] = useState<any>({})
  const [showFilter, setShowFilter] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({status: '', company_id: ''})
  const [submit, setSubmit] = useState(false)
  const [loadingMaster, setLoadingMaster] = useState<boolean>(false)
  const [selected, setSelected] = useState<any>([])
  const [counter, setCounter] = useState<any>(1)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getJobHash,
    {
      ...query,
      page: pagination.page,
      sort_field: 'created_at',
      per_page: pagination.per_page,
      status: [1, 2, 3],
      is_master: true,
      city_id: filter?.city_id,
      skill_id: filter?.skill_id,
      industry_id: filter?.industry_id,
      min_salary: filter?.min_salary,
      max_salary: filter?.max_salary,
      working_type_id: filter?.working_type_id,
      job_level: filter?.job_level,
      is_remote: filter?.is_remote,
    },
    []
  )

  const [selectedJob, setSelectedJob] = useState<any>({})
  const [isShowChangePeriod, setIsShowChangePeriod] = useState(false)

  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })
  const [role, setRole] = useState<string>('')

  const [inputs, setInputs] = useState([
    {
      name: 'city_id',
      label: 'Lokasi',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'cities_name',
      getItemValueId: 'cities_id',
    },
    {
      name: 'skill_id',
      label: 'Keahlian   ',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'skills_name',
      getItemValueId: 'skills_id',
    },
    {
      name: 'industry_id',
      label: 'Industri',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'salary',
      label: 'Gaji',
      type: 'select2',
      validation: {},
      mb: 'mb-8',
      col: 6,
      options: [
        {
          name: 'Rp 4.000.000 - Rp 6.000.000',
          value: 'Rp 4.000.000 - Rp 6.000.000',
        },
        {
          name: 'Rp 7.000.000 - Rp 10.000.000',
          value: 'Rp 7.000.000 - Rp 10.000.000',
        },
        {
          name: 'Rp 10.000.000 - Rp 15.000.000',
          value: 'Rp 10.000.000 - Rp 15.000.000',
        },
        {
          name: 'Rp 15.000.000 - Rp 25.000.000',
          value: 'Rp 15.000.000 - Rp 25.000.000',
        },
        {
          name: 'Rp 25.000.000 - Rp 30.000.000',
          value: 'Rp 25.000.000 - Rp 30.000.000',
        },
        {
          name: 'Rp 30.000.000 - Rp 50.000.000',
          value: 'Rp 30.000.000 - Rp 50.000.000',
        },
        {
          name: 'Rp 50.000.000 - Rp 70.000.000',
          value: 'Rp 50.000.000 - Rp 70.000.000',
        },
        {
          name: '> Rp 70.000.000',
          value: '> Rp 70.000.000',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    {
      name: 'working_type_id',
      label: 'Tipe Pekerjaan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'working_types_name',
      getItemValueId: 'working_types_id',
    },

    {
      name: 'job_level_id',
      label: 'Level Pekerjaan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'job_levels_name',
      getItemValueId: 'job_levels_id',
    },
    {
      name: 'is_remote',
      label: 'Dapat Dikerjakan Remote',
      type: 'select2',
      validation: {},
      col: 6,
      options: [
        {
          name: 'Ya',
          value: '1',
        },
        {
          name: 'Tidak',
          value: '0',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
  ])

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)

    setRole(localStorage.getItem('keyRole') ?? '')
  }, [pagination.per_page, pagination.page])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  useEffect(() => {
    fetchCity()
    fetchSkill()
    fetchIndustry()
    fetchWorkingType()
    fetchJobLevel()
  }, [])

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
    setShowFilter(false)
  }, [filter])

  const onKeyUp = (input: any, value: any) => {
    const name = input
    switch (name) {
      case 'city_id':
        fetchCity(value)
        break
      case 'skill_id':
        fetchSkill(value)
        break
      case 'industry_id':
        fetchIndustry(value)
        break
      case 'working_type_id':
        fetchWorkingType(value)
        break
      case 'job_level_id':
        fetchJobLevel(value)
        break
    }
  }

  const fetchCity = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getCity({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[0].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchSkill = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getSkill({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[1].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchIndustry = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getIndustry({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[2].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchWorkingType = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getWorkingType({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[4].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchJobLevel = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getJobLevel({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[5].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const handleFilter = () => {
    let salary: any = [null, null]
    if (formValue.salary?.value) {
      salary = formValue?.salary?.value
        ?.toString()
        ?.split('Rp')
        ?.join()
        ?.split(' ')
        ?.join()
        ?.replaceAll(',', '')
        ?.replaceAll('.', '')
        ?.replaceAll('>', '')
        ?.split('-')
    }

    setFilter({
      city_id: formValue?.city_id?.cities_id ? [formValue?.city_id?.cities_id] : [],
      skill_id: formValue?.skill_id?.skills_id ? [formValue?.skill_id?.skills_id] : [],
      industry_id: formValue?.industry_id?.industries_id
        ? [formValue?.industry_id?.industries_id]
        : [],
      min_salary: salary[0],
      max_salary: salary[1],
      working_type_id: formValue?.working_type_id?.working_types_id
        ? [formValue?.working_type_id?.working_types_id]
        : [],
      job_level: formValue?.job_level?.job_levels_id ? [formValue?.job_level?.job_levels_id] : [],
      is_remote: formValue?.is_remote?.value,
    })
  }

  const handleReset = () => {
    setFormValue({})
  }

  const StatusComponent = (type: string) => {
    if (type === '1') {
      return (
        <Button
          variant='success'
          className='shadow-none btn btn-sm btn-outline btn-outline-success'
        >
          Aktif
        </Button>
      )
    }
    return (
      <Button variant='danger' className='shadow-none btn btn-sm btn-outline btn-outline-dark'>
        Non-Aktif
      </Button>
    )
  }

  const handleApprove = async () => {
    try {
      setSubmit(true)
      await MasterServices.approveCompany(formValue)
      toast.success('Proses berhasil dilakukan')
      refresh()
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleChangeStatus = async (id: any, status: any) => {
    try {
      if (window.confirm('Yakin ingin Mengubah status Pekerjaan ?')) {
        setLoading(true)
        let companyStatus = status == 1 ? 3 : 1
        await MasterServices.updateJobStatus({status: companyStatus, company_job_id: id})
        toast.success(`Status Pekerjaan Berhasil Diperbarui`)
      }
    } catch (error) {
    } finally {
      refresh()
    }
  }

  const handleCheck = (param: any) => {
    let newSelected: any = selected || []

    if (param === 'all') {
      if (selected?.length > 0) {
        newSelected = []
      } else {
        data?.data?.data?.forEach((item: any) => {
          return newSelected.push({
            company_job_id: item.company_job_id,
          })
        })
      }
    } else {
      const check = selected?.filter((f: any) => param === f.company_job_id)
      if (check.length < 1) {
        newSelected.push({
          company_job_id: param,
          status: 1,
        })
      } else {
        newSelected = selected?.filter((f: any) => f.company_job_id !== param)
      }
    }

    setSelected(newSelected)
    setCounter((val: any) => val + 1)
  }

  const handleChangePeriod = (dataJob: any) => {
    setIsShowChangePeriod(true)
    setSelectedJob(dataJob)
  }

  const handleShowChangePeriod = (isShow: boolean) => {
    setIsShowChangePeriod(isShow)
  }

  const handleRefresh = (isRefresh: any) => {
    if (isRefresh) {
      refresh()
    }
  }

  const actionBulkDelete = async (jobsId: any) => {
    try {
      setLoading(true)
      await JobServices.multipleDeleteJob({jobs_id: jobsId})
      toast.success(`Lowongan Kerja Berhasil Dihapus`)
      return
    } catch (error) {
    } finally {
      refresh()
    }
  }

  const handleBulkDelete = async () => {
    if (window.confirm('Yakin ingin hapus data?')) {
      let jobs_id: any = []
      selected?.map((item: any) => {
        jobs_id.push(item.company_job_id)
      })

      actionBulkDelete(jobs_id)
    }
  }

  const toggleFilter = () => setShowFilter(!showFilter)

  return (
    <>
      <ChangePeriod
        isShow={isShowChangePeriod}
        handleShow={handleShowChangePeriod}
        data={selectedJob}
        handleRefresh={handleRefresh}
      />

      <Modal show={showFilter} onHide={submit ? () => null : toggleFilter} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title> Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>{FormGenerator(inputs, formValue, onChange, onKeyUp, loadingMaster)}</Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => handleReset()}>
            Reset
          </Button>
          <Button onClick={() => handleFilter()}>Simpan</Button>
        </Modal.Footer>
      </Modal>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Verifikasi Pekerjaan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    onChange={(e: any) => setFormValue({...formValue, status: e.target.value})}
                  >
                    {[
                      {name: 'Verifikasi 1', value: '0'},
                      {name: 'Aktif', value: '1'},
                      {name: 'Ditolak', value: '2'},
                      {name: 'Tutup', value: '3'},
                    ].map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={item.value}
                          selected={formValue.status === item.value}
                        >
                          {item.name}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant='secondary' onClick={toggle} disabled={submit}>
                  Batalkan
                </Button>
                <Button variant='primary' disabled={submit} onClick={handleApprove}>
                  {submit ? 'Loading' : 'Simpan'}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <Button type='button' onClick={toggleFilter} className='form-control'>
                  Filter
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
            {selected.length > 0 && (
              <Row>
                <Col md={{span: 2}}>
                  <Button
                    onClick={() => handleBulkDelete()}
                    type='button'
                    className='mt-8 btn btn-secondary'
                  >
                    Hapus data terpilih ?
                  </Button>
                </Col>
              </Row>
            )}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>
                      {role != 'BPK' && (
                        <Form.Check
                          onClick={() => handleCheck('all')}
                          checked={
                            data?.data?.data.length === selected.length &&
                            data?.data?.data?.length > 0
                          }
                        />
                      )}
                    </th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={7} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={7} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td>
                            {role != 'BPK' && (
                              <Form.Check
                                onChange={() => handleCheck(item.company_job_id)}
                                checked={
                                  selected.filter(
                                    (f: any) => f.company_job_id === item.company_job_id
                                  ).length > 0
                                    ? true
                                    : false
                                }
                              />
                            )}
                          </td>
                          <td>{item.company_jobs_title}</td>
                          <td>{item?.company?.companies_name}</td>
                          <td>{dateFormat(item.created_at)}</td>
                          <td>{dateFormat(item?.company_jobs_expired_date)}</td>
                          <td>{StatusComponent(item.company_jobs_status) || '-'}</td>
                          <td>
                            <Dropdown>
                              <Dropdown.Toggle
                                id='dropdown-basic'
                                className='btn btn-primary btn-sm'
                              >
                                {'  '}
                                Aksi
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() => {
                                    navigate(`/job-search/${item.company_jobs_id}`)
                                  }}
                                >
                                  Lihat
                                </Dropdown.Item>

                                <Dropdown.Item
                                  onClick={() => {
                                    handleChangePeriod(item)
                                  }}
                                >
                                  Ubah Periode Lowongan
                                </Dropdown.Item>

                                {role != 'BPK' && (
                                  <>
                                    {item.company_jobs_status != '2' && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          handleChangeStatus(
                                            item.company_jobs_id,
                                            item.company_jobs_status
                                          )
                                        }
                                      >
                                        {item.company_jobs_status == 1
                                          ? 'Non-Aktifkan'
                                          : 'Aktifkan'}
                                      </Dropdown.Item>
                                    )}
                                  </>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const Job: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Semua Lowongan
      </PageTitle>
      <CompanyPage />
    </>
  )
}

export default Job
